import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isSdkDebuggerRecordingIdLogsResult = objectOf({
  url: string,
});
